<div class="dialog-header">
  <div class="header-title">
    <span style="font-size: 125%;" *ngIf="!data.fromKiosk">{{breakName}}</span>
    <span style="font-size: 125%;" *ngIf="data.fromKiosk">{{timeCard.startTime | date: 'EEEE, MMMM d, y'}}</span>
  </div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content timesheet-dialog" [ngClass]="{'disabled-content': loadingSpinner}">

  <form #timeEditForm="ngForm">
    <div class="form-block">
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>person</mat-icon>
        </div>
        <div class="field-block">
          <mat-select *ngIf="selectedUser" [(value)]="selectedUser" [disabled]="!currentUser.adminNSales">
            <mat-select-trigger>{{selectedUser.username}}</mat-select-trigger>
            <mat-option *ngFor="let user of users" [value]="user">
              <span class="type-text">{{user.username}}</span>
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>work</mat-icon>
        </div>
        <div class="field-block">
          <mat-select *ngIf="currentJob" [(value)]="currentJob.id">
            <mat-select-trigger>{{currentJob.name}}</mat-select-trigger>
            <mat-option *ngFor="let job of jobs" [value]="job.id" (click)="selectJobChanged(job)">
              <span class="type-text">{{job.name}}</span>
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="form-row">
        <div class="label-block">
          <!-- <mat-icon>alarm</mat-icon> -->
          Start
        </div>
        <div class="field-block calendar-block" *ngIf="!data.fromKiosk">
          <p-calendar [(ngModel)]="startDate" view="date" [tabindex]="-1" type="date" readonly="readonly"
                      [showTime]="true" hourFormat="12" [stepMinute]="5" [touchUI]="true" name="firstDate"
                      [showIcon]="true" [ngModelOptions]="{standalone: true}" [readonlyInput]="false"
                      (onShow)="blurActiveElement()"
                      [showOnFocus]="false" [hideOnDateTimeSelect]="false">
          </p-calendar>
        </div>
        <div class="field-block calendar-block" *ngIf="data.fromKiosk">
          <p-calendar [(ngModel)]="startDate" view="date" [tabindex]="-1" type="date" readonly="readonly"
                      [showTime]="true" hourFormat="12" [stepMinute]="5" name="firstDate" [disabled]="true"
                      (onShow)="blurActiveElement()"
                      [showIcon]="true" [ngModelOptions]="{standalone: true}" [timeOnly]="true" appendTo="body">
          </p-calendar>
        </div>
      </div>
      <div class="form-row">
        <div class="label-block">
          <!-- <mat-icon>alarm</mat-icon> -->
          End
        </div>
        <div class="field-block calendar-block" *ngIf="!data.fromKiosk">
          <p-calendar [(ngModel)]="endDate" view="date" [tabindex]="-1" type="date" readonly="readonly"
                      [showTime]="true" hourFormat="12" [stepMinute]="5" [touchUI]="true" name="secondDate"
                      [showIcon]="true" [ngModelOptions]="{standalone: true}" [readonlyInput]="false"
                      (onShow)="blurActiveElement()"
                      [showOnFocus]="false" [hideOnDateTimeSelect]="false">
          </p-calendar>
        </div>
        <div class="field-block calendar-block" *ngIf="data.fromKiosk">
          <p-calendar [(ngModel)]="endDate" view="date" [tabindex]="-1" type="date" readonly="readonly"
                      [showTime]="true" hourFormat="12" [stepMinute]="5" name="secondDate"
                      [showIcon]="true" [ngModelOptions]="{standalone: true}" [timeOnly]="sameDay"
                      [touchUI]="!sameDay" (onShow)="blurActiveElement()"
                      [hideOnDateTimeSelect]="!sameDay" [showOnFocus]="sameDay">
          </p-calendar>
        </div>
      </div>
      <div class="form-row" *ngIf="!data.fromKiosk">
        <div class="icon-block">
          <mat-icon>notes</mat-icon>
        </div>
        <div class="field-block">
          <mat-form-field>
						<textarea matInput placeholder="Modifying Reason" type="text" [required]="true" [(ngModel)]="notes"
                      name="notes"></textarea>
          </mat-form-field>

        </div>
      </div>

    </div>
    <div class="save-btn-block">
      <div class="flex-box">

      </div>
      <button mat-button class="save-btn" (click)="saveTimeButton()" [disabled]="!timeEditForm.form.valid"
              tabindex="1" type="submit" [ngClass]="{'disabled-button': !timeEditForm.form.valid}">
        <span *ngIf="!loadingSpinner">{{buttonLabel}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>
      <div class="flex-box">
        <button *ngIf="buttonLabel === 'Save' && !data.fromKiosk" mat-button class="delete-item-button"
                (click)="deleteTimeCard()">
          <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
        </button>

        <p-confirmDialog header="Delete Time Card?" appendTo="body" icon="pi pi-trash"
                         styleClass="time-sheet-edit-dialog">
        </p-confirmDialog>
      </div>
    </div>
  </form>
</div>
